export const lowerCaseAndSpace = (string) => {
	if (string) {
		const formattedString = string.replace(/\s+/g, '_').toLowerCase();
		return formattedString;
	} else {
		console.error('No string in field');
		return null
	}
};
